import { type NotificaResponseDTO } from '@framework/api-client/api/backoffice/schemas/notificaResponseDTO.ts';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

interface INotificationReadStatusProps {
  notification: NotificaResponseDTO;
}

/**
 * Stato di lettura della notifica tramite tag.
 * Non letta: tag con colore primario. Letta: tag default.
 */
export function NotificationReadStatus({
  notification,
}: INotificationReadStatusProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isRead = !!notification.dataPresaVisione;

  if (isRead) {
    return <Tag>{t('notifiche.letta', 'Letta')}</Tag>;
  }

  return (
    <Tag color={theme.colorPrimary}>
      {t('notifiche.non-letta', 'Non letta')}
    </Tag>
  );
}
